import { useNavigate } from "react-router-dom";
import { Flex, Spin } from "@payping/web-components";
import useTranslator from "@/shared/translate/translator";
import { Constants as routerConstants } from "@/refund/routes";
import { useGetUserConfiguration } from "@/refund/use-cases";
import { useEffect } from "react";

const Init: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslator("refund.check");

  const getUserConfiguration = useGetUserConfiguration();

  useEffect(() => {
    if (!getUserConfiguration.isLoading) {
      if (getUserConfiguration.isSuccess) navigate(routerConstants.wallet.url);
      else {
        const status = (getUserConfiguration?.error as unknown as Response)?.status;
        if (status === 400) navigate(routerConstants.init.url);
        // todo :process other status
      }
    }
  }, [getUserConfiguration, navigate]);

  return (
    <Flex vertical justify="center" align="center" className="tw:h-[60vh]">
      <Spin tip={t("loading")} size="large">
        <div className="tw:p-[50px]!" />
      </Spin>
    </Flex>
  );
};
export default Init;
